/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsFeaturedCollection = {
  init: function($section) {

    // Add settings from schema to current object
    Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

    if(this.enable_masonry_layout && !this.align_height && this.collection_style == 'grid') {
      Shopify.theme.applyMasonry();
    }

    if(this.collection_style == 'slider') {
      this.createSlider();
    }

    if(this.collection_style == 'mobile-slider' && $(window).width() < 799) {
      this.createSliderMobile();
    }


  },
  createSlider: function() {

    let featuredCollectionSlider = $('.featured-collection.layout--slider .slider-gallery');

    const slideData = {
      products_per_slide: this.products_per,
      products_available: this.products_available,
      products_limit: this.products_limit,
      cellAlign: "left",
      wrapAround: true
    }

    $(featuredCollectionSlider).flickity({
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'left',
      wrapAround: slideData.wrapAround,
      pageDots: false,
      contain: true,
      prevNextButtons: false,
      initialIndex: 0,
      arrowShape: arrowShape,
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          $(featuredCollectionSlider).on( 'settle.flickity', function() {
            $(featuredCollectionSlider).flickity('resize')
          });
        },
        scroll: function(progress){
            var progressBar = $(featuredCollectionSlider).parent().find('.progress-bar')
            progress = Math.max( 0, Math.min( 1, progress ) );
            $(progressBar).css('width',progress * 100 + '%')

        }
      }
    });

  },
  createSliderMobile: function() {

    let featuredCollectionSliderMobile = $('.featured-collection.layout--mobile-slider');

    const slideData = {
      products_per_slide: this.products_per,
      products_available: this.products_available,
      products_limit: this.products_limit,
      cellAlign: "left",
      wrapAround: true
    }

    $(featuredCollectionSliderMobile).flickity({
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'left',
      wrapAround: slideData.wrapAround,
      pageDots: false,
      contain: true,
      prevNextButtons: false,
      initialIndex: 0,
      arrowShape: arrowShape,
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          $(featuredCollectionSliderMobile).on( 'settle.flickity', function() {
            $(featuredCollectionSliderMobile).flickity('resize')
          });
        },
        scroll: function(progress){
            var progressBar = $(featuredCollectionSliderMobile).parent().find('.progress-bar')
            progress = Math.max( 0, Math.min( 1, progress ) );
            $(progressBar).css('width',progress * 100 + '%')

        }
      }
    });

  },
  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}

/******/ })()
;